module.exports = __webpack_public_path__ + "img/business-s1.612968fe.png";